var _style, _circle, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNoMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30613;}\n\t.st1{opacity:0.15;fill:#B1B7C5;}\n\t.st2{clip-path:url(#SVGID_1_);}\n\t.st3{fill:#B1B7C5;}\n\t.st4{fill:#808693;}\n\t.st5{fill:#FCFCFC;}\n\t.st6{fill:#EFF1F3;}\n\t.st7{fill:#E6E6E6;}\n\t.st8{opacity:0.72;fill:#B1B7C5;}\n\t.st9{fill:#00BDAA;}\n\t.st10{opacity:0.72;}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.5,
    cy: 283.5,
    r: 212.6
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 283.5,
    cy: 283.5,
    r: 212.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "427.5,520.5 233,575.9 13.4,391.2 427.5,391.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M451.2,391.2l-1214.9,0c-9,0-16.3-7.3-16.3-16.3v-7.7c0-9,7.3-16.3,16.3-16.3H451.2 c9,0,16.3,7.3,16.3,16.3v7.7C467.5,383.9,460.2,391.2,451.2,391.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.4,394H-759.9c-12.6,0-22.9-10.3-22.9-22.9c0-12.6,10.3-22.9,22.9-22.9H447.4 c12.6,0,22.9,10.3,22.9,22.9C470.2,383.7,460,394,447.4,394z M-759.9,353.7c-9.6,0-17.4,7.8-17.4,17.4 c0,9.6,7.8,17.4,17.4,17.4H447.4c9.6,0,17.4-7.8,17.4-17.4c0-9.6-7.8-17.4-17.4-17.4H-759.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 351.3,
    cy: 370.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 232.2,
    cy: 370.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 114.4,
    cy: 370.7,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 441.2,
    cy: 370.7,
    r: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 196.8,
    className: "st8",
    width: 151,
    height: 151.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 196.8,
    className: "st6",
    width: 35.1,
    height: 17.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 236.2,
    y: 196.8,
    className: "st8",
    width: 151,
    height: 151.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.1,
    y: 196.8,
    className: "st6",
    width: 35.1,
    height: 17.6
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNoMachines);
export default __webpack_public_path__ + "static/media/dashboard_no_machines.104113b940cf513b2ad7220894671b4e.svg";
export { ForwardRef as ReactComponent };